import type { RoadSectionId } from '../../domain/Reference';
import { createCommand } from '../../utils';
import { SelectRoadSectionsCommand } from './SelectRoadSectionsCommand';

// Selecting a single section (a plain click on the map, or its neighbor) opens the object sheet on it.
export const SelectRoadSectionCommand = createCommand<RoadSectionId>(
    'MAP_V2/SELECT_ROAD_SECTION',
    async (id, { dispatch }) => {
        await dispatch(SelectRoadSectionsCommand({ ids: [id], anchor: id }));
    },
);
